<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Near Miss Safety Investigations'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Incident Date/Time'"
                            [binding]="'incidentDateTime'"
                            [format]="'g'"
                            [width]="170"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job Site'"
                            [binding]="'jobDisplay'"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Parties Involved'"
                            [binding]="'partiesInvolved'"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Description'"
                            [binding]="'description'"
                            [width]="'2*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Corrective Action'"
                            [binding]="'correctiveAction'"
                            [width]="'2*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
